import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSharedModule } from '@homeleite/default-shared';
import { LayoutBaseModule } from '../base/layout-base.module';
import { LayoutAdminComponent } from './layout-admin.component';
import { MenuModule } from './menu/menu.module';
import { IntegrationAlertsBellComponent } from './integration-alerts-bell.component';

const COMPONENTS = [
  LayoutAdminComponent,
  IntegrationAlertsBellComponent
]

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    DefaultSharedModule,
    LayoutBaseModule,
    MenuModule,
  ],
  exports: COMPONENTS
})
export class LayoutAdminModule { }
